import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconBasePath, IconName, ICONS } from './icon.register';

@Injectable({
  providedIn: 'root',
})
export class IconLoaderService {
  private readonly registry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private loaded = new Set<IconName>();

  ensure(name: IconName) {
    if (this.loaded.has(name)) return;
    const path = ICONS[name];
    if (!path) {
      if (ngDevMode) {
        console.warn(`[Icon] "${name}" is not registered`);
      }
      return;
    }
    this.registry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(IconBasePath + path));
    this.loaded.add(name);
  }

}
